<script lang="ts">
  import { pop, push } from 'svelte-spa-router';

  /**
   * 「一つ上の画面に戻る」共通導線。
   * - `to` を指定した場合はそのパスへ遷移する（例: 支出編集画面から日別一覧へ確実に戻したい場合）。
   * - 未指定の場合は履歴を1つ戻る（ブラウザの戻るボタンと同等）。
   */
  interface Props {
    to?: string;
    label?: string;
  }

  let { to = undefined, label = '戻る' }: Props = $props();

  function handleClick() {
    if (to) {
      push(to);
    } else {
      pop();
    }
  }
</script>

<button type="button" class="back-button" onclick={handleClick} aria-label={label}>
  <span class="back-button__icon" aria-hidden="true">←</span>
  <span class="back-button__label">{label}</span>
</button>

<style>
  .back-button {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    background: transparent;
    border: none;
    color: var(--color-text);
    font-size: 0.95rem;
    line-height: 1;
    padding: 0.5rem 0.5rem 0.5rem 0.25rem;
    border-radius: var(--radius-sm);
    cursor: pointer;
  }

  .back-button:hover,
  .back-button:focus-visible {
    background-color: var(--color-bg-elevated);
  }

  .back-button__icon {
    font-size: 1.1rem;
  }
</style>
